import React, { useState, useEffect } from "react";
import { getPhotoList } from "../../../api/const";
import Photo_new from "../../../pages/const/Photo_new";

import SearchBar from "../../../components/common/board/SearchFilterBar";
import BoardToolbar from "../../../components/common/board/BoardToolbar";
import BoardPagination from "../../../components/common/board/BoardPagination";

export default function PhotoListModal({
  projectId,
  isOpen,
  onClose,
  onSelect,
}) {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(false);

  // 검색 필터 (Photo UI와 동일하게 구성)
  const [q, setQ] = useState("");
  const [searchField, setSearchField] = useState("title");
  const [dateFilter, setDateFilter] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(0);

  // 페이지네이션
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(9); // 모달이므로 조금 줄임
  const [total, setTotal] = useState(0);

  const [isUploadOpen, setIsUploadOpen] = useState(false);

  const fetchPhotos = () => {
    if (!projectId) return;

    setLoading(true);

    const params = {
      [searchField]: q,
      start_date: startDate,
      end_date: endDate,
      page,
      page_size: pageSize,
    };

    getPhotoList(projectId, params)
      .then((res) => {
        setPhotos(res.results ?? res);
        setTotal(res.count ?? res.total ?? res.length);
      })
      .catch((err) => console.error("사진 로드 실패:", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isOpen) {
      fetchPhotos();
      setPage(1);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) fetchPhotos();
  }, [page, pageSize, searchTrigger]);

  if (!isOpen) return null;

  const handleSearch = () => {
    setPage(1);
    setSearchTrigger((v) => v + 1);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[200]">
      <div className="bg-white rounded-xl shadow-xl w-[1100px] max-h-[90vh] overflow-hidden flex flex-col">

        {/* 툴바 (검색 + 버튼)*/}
        <div className="p-4 border-b bg-gray-50">
          <BoardToolbar
            right={
              <>
              <SearchBar
                q={q}
                onChangeQ={setQ}
                searchField={searchField}
                onChangeSearchField={setSearchField}
                dateFilter={dateFilter}
                onChangeDateFilter={setDateFilter}
                startDate={startDate}
                endDate={endDate}
                onDateChange={({ start, end }) => {
                  setStartDate(start);
                  setEndDate(end);
                }}
                onSearch={handleSearch}
                pageSize={pageSize}
                onChangePageSize={setPageSize}
                searchFieldOptions={[{ value: "title", label: "제목" }]}
              />

                <div className="flex gap-2 ml-4">
                  <button
                    onClick={() => setIsUploadOpen(true)}
                    className="btn-create"
                  >
                    새 사진 등록
                  </button>

                  <button
                    onClick={onClose}
                    className="btn-basic"
                  >
                    닫기
                  </button>
                </div>
              </>
            }
          />
        </div>

        {/* 사진 목록*/}
        <div className="flex-1 overflow-auto page-box">
          {loading ? (
            <div className="text-center py-12 text-muted-sm">로딩 중...</div>
          ) : photos.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-muted mb-3">등록된 사진이 없습니다.</p>
            </div>
          ) : (
            <div className="grid grid-cols-3 gap-4">
              {photos.map((p) => (
                <div
                  key={p.id}
                  onClick={() => {
                    onSelect(p);
                    onClose();
                  }}
                  className="bg-gray-50 border rounded-lg overflow-hidden shadow-sm hover:shadow-md 
                             cursor-pointer transition flex flex-col relative"
                >
                  <div className="w-full h-36 bg-gray-100 flex items-center justify-center">
                    <img
                      src={p.file_url}
                      alt={p.title}
                      className="max-h-full object-contain"
                    />
                  </div>

                  <div className="p-2">
                    <h3 className="text-body-bold truncate">{p.title}</h3>
                    <p className="text-xs text-gray-500">
                      {p.date ? new Date(p.date).toLocaleDateString() : ""}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* 페이지네이션*/}
        <div className="border-t p-3">
          <BoardPagination
            page={page}
            pageSize={pageSize}
            total={total}
            onPageChange={setPage}
          />
        </div>

        {/* 사진 등록 모달*/}
        <Photo_new
          projectId={projectId}
          isOpen={isUploadOpen}
          onClose={() => setIsUploadOpen(false)}
          onCreated={fetchPhotos}
        />
      </div>
    </div>
  );
}
